import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  FormGroup,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import ServiceModule from "../../../services/KangarooServices/ServiceModule";
import MediaService from "../../../services/KangarooServices/MediaServices";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MediaModal from "../../PagesSection/Component/MediaModal";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import { useQuill } from "react-quilljs"; // This was unused
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { imageBaseApi } from "../../../utilis/imageHelper";
import ColorPicker from "../../../Components/ColorPicker/ColorPicker";
import PageService from "../../../services/KangarooServices/PageService";

const ServiceForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mediaData, setMediaData] = useState([]);
  const [details, setDetails] = useState(null);
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [mediaTarget, setMediaTarget] = useState(null);
  const [activeMainTab, setActiveMainTab] = useState("1"); // For main tabs
  const [activeSubTab, setActiveSubTab] = useState(0); // For subDetails
  const [bannerMedia, setBannerMedia] = useState(null);
  const [thumbailMedia, setThumbailMedia] = useState(null);

  const [slugMessage, setSlugMessage] = useState(""); // message text
  const [isSlugValid, setIsSlugValid] = useState(true); // validity

  const [activeMenuTabs, setActiveMenuTabs] = useState({});
  const [expandedContents, setExpandedContents] = useState({});

  const getActiveMenuTab = (dIndex) => {
    return activeMenuTabs[dIndex] || 0;
  };
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: null,
  });

  const openConfirmModal = ({ title, message, onConfirm }) => {
    setConfirmModal({
      open: true,
      title,
      message,
      onConfirm,
    });
  };

  const closeConfirmModal = () => {
    setConfirmModal({
      open: false,
      title: "",
      message: "",
      onConfirm: null,
    });
  };

  const setActiveMenuTab = (dIndex, mIndex) => {
    setActiveMenuTabs((prev) => ({ ...prev, [dIndex]: mIndex }));
  };

  const toggleContentExpand = (dIndex, mIndex, cIndex) => {
    const key = `${dIndex}-${mIndex}-${cIndex}`;
    setExpandedContents((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  /* ---------------- HELPERS ---------------- */
  const generateSlug = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-");

  const checkSlug = async (slug) => {
    if (!slug) return;
    try {
      const res = await ServiceModule.checkSlug({ slug });
      setIsSlugValid(!res.exists);
      setSlugMessage(
        res.exists
          ? `Slug taken. Suggested: ${res.suggestedSlug}`
          : "Slug available"
      );
    } catch {
      setIsSlugValid(false);
      setSlugMessage("Unable to check slug");
    }
  };
  // Fetch media list
  const fetchMedia = async () => {
    try {
      const response = await MediaService.getList({ page: 1, pageSize: 1000 });
      setMediaData(response?.items || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load media library");
    }
  };

  // Fetch service detail if editing
  const fetchDetail = async () => {
    if (!id) return;
    try {
      const result = await ServiceModule.getBySlug(id);
      setDetails(result);

      if (result.bannerMedia) {
        setBannerMedia({
          id: result.bannerMediaId,
          url: result.bannerMedia.url,
          fileName: result.bannerMedia.fileName,
          mimeType: result.bannerMedia.mimeType,
          size: result.bannerMedia.size,
        });
      }
      if (result.thumbnailMedia) {
        setThumbailMedia({
          id: result.thumbnailMediaId,
          url: result.thumbnailMedia.url,
          fileName: result.thumbnailMedia.fileName,
          mimeType: result.thumbnailMedia.mimeType,
          size: result.thumbnailMedia.size,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch service details");
    }
  };

  useEffect(() => {
    fetchMedia();
    if (id) fetchDetail();
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: details?.name || "",
      orderIndex: details?.orderIndex || 0,
      bannerMediaId: details?.bannerMediaId || null,
      thumbnailMediaId: details?.thumbnailMediaId || null,
      bannerText: details?.bannerText || "",
      bannerButtonText: details?.bannerButtonText || "",
      bannerTextColorCode: details?.bannerTextColorCode || "#000",
      mainDescription: details?.mainDescription || "",
      description: details?.description || "",
      isActive: details?.isActive ?? true,
      videoUrl: details?.videoUrl || "",
      bannerButtonColorCode: details?.bannerButtonColorCode || "#000",
      slug: details?.slug || "",
      subDetails:
        details?.subDetails?.length > 0
          ? details.subDetails.map((d) => ({
              id: d.id || null,
              title: d.title || "",
              description: d.description || "",
              orderIndex: d.orderIndex || 0,
              menus:
                d.subDetailsMenus?.length > 0
                  ? d.subDetailsMenus.map((m) => ({
                      title: m.title || "",
                      orderIndex: m.orderIndex || 0,
                      description: m.description || "",
                      pdfId: m.pdfId || null,
                      pdf: m.pdf || {},
                      contents:
                        m.contents?.length > 0
                          ? m.contents.map((c) => ({
                              heading: c.heading || "",
                              description: c.description || "",
                              mediaId: c.mediaId || null,
                              media: c.media || null,
                              orderIndex: c.orderIndex || 0,
                            }))
                          : [], // ← FIXED: Allow empty contents
                    }))
                  : [], // ← FIXED: Allow empty menus
            }))
          : [], // ← FIXED: Allow empty subDetails on load
    },

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          slug: values?.slug,
          name: values.name,
          orderIndex: values.orderIndex,
          bannerMediaId: values.bannerMediaId,
          thumbnailMediaId: values?.thumbnailMediaId,
          bannerText: values.bannerText,
          bannerButtonText: values.bannerButtonText,
          bannerButtonColorCode: values.bannerButtonColorCode,
          bannerTextColorCode: values.bannerTextColorCode,
          mainDescription: values.mainDescription,
          description: values.description,
          isActive: values.isActive,
          videoUrl: values.videoUrl,
          subDetails: values.subDetails.map((detail) => ({
            id: detail.id || null,
            title: detail.title,
            description: detail?.description,
            orderIndex: detail.orderIndex,
            menus:
              detail.menus?.map((menu) => ({
                title: menu.title,
                description: menu.description,
                orderIndex: menu.orderIndex,
                pdfId: menu.pdfId || null,
                contents:
                  menu.contents?.map((content) => ({
                    heading: content.heading,
                    description: content.description,
                    mediaId: content.mediaId || null,
                    orderIndex: content.orderIndex,
                  })) || [],
              })) || [],
          })),
        };

        if (id) {
          await ServiceModule.update(details?.id, payload);
          toast.success("Service updated successfully!");
        } else {
          await ServiceModule.create(payload);
          toast.success("Service created successfully!");
        }
        navigate("/service");
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Failed to save service");
      } finally {
        setLoading(false);
      }
    },
  });

  // Media modal
  const openMediaModal = (target) => {
    setMediaTarget(target);
    setIsMediaOpen(true);

    // If targeting a subDetail (for its cover? but in your code it's not used, but keep if needed)
    if (typeof target === "number") {
      setActiveSubTab(target);
    }
  };

  const handleMediaSelect = (media) => {
    if (!mediaTarget) return;

    if (mediaTarget === "banner") {
      setBannerMedia(media);
      formik.setFieldValue("bannerMediaId", media.id);
    } else if (mediaTarget === "thumbail") {
      setThumbailMedia(media);
      formik.setFieldValue("thumbnailMediaId", media.id);
    } else if (mediaTarget.type === "pdf") {
      const { dIndex, mIndex } = mediaTarget;
      formik.setFieldValue(
        `subDetails[${dIndex}].menus[${mIndex}].pdfId`,
        media.id
      );
    } else if (mediaTarget.type === "content") {
      const { dIndex, mIndex, cIndex } = mediaTarget;
      formik.setFieldValue(
        `subDetails[${dIndex}].menus[${mIndex}].contents[${cIndex}].mediaId`,
        media.id
      );
      formik.setFieldValue(
        `subDetails[${dIndex}].menus[${mIndex}].contents[${cIndex}].media`,
        media
      );
    }

    setIsMediaOpen(false);
    setMediaTarget(null);
  };

  const addSubDetail = () => {
    formik.setFieldValue("subDetails", [
      ...formik.values.subDetails,
      { title: "", link: "", description: "", orderIndex: 0, mediaId: null },
    ]);
    formik.setFieldValue("selectedMedia", [
      ...(formik.values.selectedMedia || []),
      null,
    ]);
    setActiveSubTab(formik.values.subDetails.length);
  };

  const removeSubDetail = (index) => {
    const newDetails = formik.values.subDetails.filter((_, i) => i !== index);
    formik.setFieldValue("subDetails", newDetails);

    // Adjust active tab if needed
    if (newDetails.length === 0) {
      setActiveSubTab(0);
    } else if (activeSubTab >= newDetails.length) {
      setActiveSubTab(newDetails.length - 1);
    }
  };
  const removeMenu = (dIndex, mIndex) => {
    const menus = [...formik.values.subDetails[dIndex].menus];
    menus.splice(mIndex, 1);

    formik.setFieldValue(`subDetails[${dIndex}].menus`, menus);

    // Fix active menu tab after delete
    const currentActive = getActiveMenuTab(dIndex);
    if (currentActive === mIndex) {
      setActiveMenuTab(dIndex, Math.max(0, mIndex - 1));
    }
  };

  const removeBanner = () => {
    setBannerMedia(null);
    formik.setFieldValue("bannerMediaId", null);
  };
  const removeThumbail = () => {
    setThumbailMedia(null);
    formik.setFieldValue("thumbnailMediaId", null);
  };
  const handleRemovePdf = (dIndex, mIndex) => {
    formik.setFieldValue(`subDetails[${dIndex}].menus[${mIndex}].pdfId`, null);
    formik.setFieldValue(`subDetails[${dIndex}].menus[${mIndex}].pdf`, null);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={id ? "Edit Service" : "Add Service"}
          pageTitle="Service"
          breadcrumbItems={[{ title: "Back to List", link: "/service" }]}
        />

        <div>
          <form onSubmit={formik.handleSubmit}>
            <div className="d-flex justify-content-end gap-3 mt-3">
              <Button type="submit" color="success" disabled={loading}>
                {loading ? "Saving..." : id ? "Update" : "Create"}
              </Button>
              <Button
                type="button"
                color="soft-danger"
                onClick={() => navigate("/service")}
                disabled={loading}
              >
                Cancel
              </Button>
            </div>
            {/* Main tabs */}
            <Nav tabs className="mb-3">
              <NavItem>
                <NavLink
                  active={activeMainTab === "1"}
                  onClick={() => setActiveMainTab("1")}
                  style={{ cursor: "pointer" }}
                >
                  Main Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  active={activeMainTab === "2"}
                  onClick={() => setActiveMainTab("2")}
                  style={{ cursor: "pointer" }}
                >
                  Banner Media
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  active={activeMainTab === "3"}
                  onClick={() => setActiveMainTab("3")}
                  style={{ cursor: "pointer" }}
                >
                  Service Details
                </NavLink>
              </NavItem>
            </Nav>

            {/* Submit Buttons */}

            <TabContent activeTab={activeMainTab}>
              {/* Main Info Tab */}
              <TabPane tabId="1">
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={6} className="mb-2">
                        <Label>
                          Service Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="name"
                          value={formik.values.name}
                          onChange={(e) => {
                            formik.setFieldValue("name", e.target.value);
                            if (!id) {
                              const slug = generateSlug(e.target.value);
                              formik.setFieldValue("slug", slug);
                              checkSlug(slug);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          invalid={formik.touched.name && !!formik.errors.name}
                        />
                        {formik.touched.name && formik.errors.name && (
                          <div className="text-danger mt-1">
                            {formik.errors.name}
                          </div>
                        )}
                      </Col>
                      <Col>
                        <FormGroup className="mb-2">
                          <Label htmlFor="slug">
                            Slug <span className="text-danger">*</span>
                          </Label>
                          <Input
                            invalid={!isSlugValid}
                            value={formik.values.slug}
                            onBlur={(e) => checkSlug(e.target.value)}
                            onChange={(e) =>
                              formik.setFieldValue("slug", e.target.value)
                            }
                          />
                          <small
                            className={
                              isSlugValid ? "text-success" : "text-danger"
                            }
                          >
                            {slugMessage}
                          </small>
                        </FormGroup>
                      </Col>
                      <Col md={6} className="mb-2">
                        <Label>
                          Video Url <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="videoUrl"
                          value={formik.values.videoUrl}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.videoUrl && !!formik.errors.videoUrl
                          }
                        />
                        {formik.touched.videoUrl && formik.errors.videoUrl && (
                          <div className="text-danger mt-1">
                            {formik.errors.videoUrl}
                          </div>
                        )}
                      </Col>
                      <Col md={6} className="mb-2">
                        <Label>
                          Order Index <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          name="orderIndex"
                          value={formik.values.orderIndex}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.orderIndex &&
                            !!formik.errors.orderIndex
                          }
                        />
                        {formik.touched.orderIndex &&
                          formik.errors.orderIndex && (
                            <div className="text-danger mt-1">
                              {formik.errors.orderIndex}
                            </div>
                          )}
                      </Col>
                      <Col md={12} className="mb-2">
                        <FormGroup>
                          <Label>
                            Main Description{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formik.values.mainDescription}
                            onChange={(event, editor) =>
                              formik.setFieldValue(
                                "mainDescription",
                                editor.getData()
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <Label>
                            Description 
                          </Label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formik.values.description}
                            onChange={(event, editor) =>
                              formik.setFieldValue(
                                "description",
                                editor.getData()
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane>

              {/* Banner Media Tab */}
              <TabPane tabId="2">
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={6} className="mb-2">
                        <Label>Banner Text</Label>
                        <Input
                          name="bannerText"
                          value={formik.values.bannerText}
                          onChange={formik.handleChange}
                        />
                      </Col>
                      <Col md={6} className="mb-2">
                        <Label>Banner Button Text</Label>
                        <Input
                          name="bannerButtonText"
                          value={formik.values.bannerButtonText}
                          onChange={formik.handleChange}
                        />
                      </Col>
                      <Col md={6} className="mb-2">
                        <FormGroup>
                          <Label>Banner Text Color</Label>
                          <ColorPicker
                            value={formik.values.bannerTextColorCode}
                            onChange={(color) =>
                              formik.setFieldValue("bannerTextColorCode", color)
                            }
                            isToggle={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6} className="mb-2">
                        <FormGroup>
                          <Label>Button Color</Label>
                          <ColorPicker
                            value={formik.values.bannerButtonColorCode}
                            onChange={(color) =>
                              formik.setFieldValue(
                                "bannerButtonColorCode",
                                color
                              )
                            }
                            isToggle={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <Label>Cover Media (Banner)</Label>
                        {bannerMedia ? (
                          <div className="text-center p-3 border rounded shadow-sm bg-light">
                            <div
                              style={{
                                maxHeight: "220px",
                                overflow: "hidden",
                                borderRadius: "10px",
                                border: "1px solid #ddd",
                              }}
                              className="mb-3"
                            >
                              <img
                                src={`${imageBaseApi}${bannerMedia.url}`}
                                alt="Banner"
                                style={{ width: "100%", objectFit: "contain" }}
                                className="img-fluid"
                              />
                            </div>
                            <div className="mb-2">
                              <div className="fw-semibold">
                                {bannerMedia.fileName}
                              </div>
                              {bannerMedia.size && (
                                <small className="text-muted">
                                  Size: {(bannerMedia.size / 1024).toFixed(1)}{" "}
                                  KB
                                </small>
                              )}
                            </div>
                            <div className="d-flex gap-2 justify-content-center">
                              <Button
                                size="sm"
                                outline
                                color="primary"
                                onClick={() => openMediaModal("banner")}
                              >
                                Change
                              </Button>
                              <Button
                                size="sm"
                                outline
                                color="danger"
                                onClick={removeBanner}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div className="p-4 border rounded text-center bg-light">
                            <i className="ri-image-add-line fs-1 text-secondary"></i>
                            <h6 className="mt-2 mb-3 text-muted">
                              No banner image selected
                            </h6>
                            <Button
                              outline
                              color="secondary"
                              onClick={() => openMediaModal("banner")}
                            >
                              <i className="ri-image-add-line me-1"></i> Choose
                              Banner Image
                            </Button>
                          </div>
                        )}
                      </Col>

                      <Col>
                        <Label>Thumbail Media</Label>
                        {thumbailMedia ? (
                          <div className="text-center p-3 border rounded shadow-sm bg-light">
                            <div
                              style={{
                                maxHeight: "220px",
                                overflow: "hidden",
                                borderRadius: "10px",
                                border: "1px solid #ddd",
                              }}
                              className="mb-3"
                            >
                              <img
                                src={`${imageBaseApi}${thumbailMedia.url}`}
                                alt="Banner"
                                style={{ width: "100%", objectFit: "contain" }}
                                className="img-fluid"
                              />
                            </div>
                            <div className="mb-2">
                              <div className="fw-semibold">
                                {thumbailMedia.fileName}
                              </div>
                              {thumbailMedia.size && (
                                <small className="text-muted">
                                  Size: {(thumbailMedia.size / 1024).toFixed(1)}{" "}
                                  KB
                                </small>
                              )}
                            </div>
                            <div className="d-flex gap-2 justify-content-center">
                              <Button
                                size="sm"
                                outline
                                color="primary"
                                onClick={() => openMediaModal("thumbail")}
                              >
                                Change
                              </Button>
                              <Button
                                size="sm"
                                outline
                                color="danger"
                                onClick={removeThumbail}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div className="p-4 border rounded text-center bg-light">
                            <i className="ri-image-add-line fs-1 text-secondary"></i>
                            <h6 className="mt-2 mb-3 text-muted">
                              No thumbail image selected
                            </h6>
                            <Button
                              outline
                              color="secondary"
                              onClick={() => openMediaModal("thumbail")}
                            >
                              <i className="ri-image-add-line me-1"></i> Choose
                              Thumbail Image
                            </Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane>
              <TabPane tabId="3">
                <Card className="border-0 shadow-sm">
                  <CardHeader className="bg-white border-bottom">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h4
                          className="mb-1"
                          style={{ fontWeight: 600, color: "#2c3e50" }}
                        >
                          Service Details
                        </h4>
                        <p className="text-muted small mb-0">
                          Manage your service content structure
                        </p>
                      </div>
                      <Button
                        color="primary"
                        onClick={addSubDetail}
                        className="d-flex align-items-center gap-2"
                      >
                        <i className="ri-add-line"></i>
                        Add Detail Section
                      </Button>
                    </div>
                  </CardHeader>

                  <CardBody className="p-0">
                    {/* Modern Tabs */}
                    <div
                      style={{
                        borderBottom: "1px solid #e9ecef",
                        backgroundColor: "#fff",
                        padding: "0 1.5rem",
                      }}
                    >
                      <Nav
                        className="nav-tabs border-0"
                        style={{ marginBottom: "-1px" }}
                      >
                        {formik.values.subDetails.map((detail, index) => (
                          <NavItem key={index}>
                            <NavLink
                              active={activeSubTab === index}
                              onClick={() => setActiveSubTab(index)}
                              className="d-flex align-items-center gap-2 position-relative"
                              style={{
                                cursor: "pointer",
                                border: "none",
                                borderBottom:
                                  activeSubTab === index
                                    ? "3px solid #0d6efd"
                                    : "3px solid transparent",
                                color:
                                  activeSubTab === index
                                    ? "#0d6efd"
                                    : "#6c757d",
                                fontWeight: activeSubTab === index ? 600 : 400,
                                padding: "0.75rem 1rem",
                                backgroundColor: "transparent",
                                transition: "all 0.2s",
                              }}
                            >
                              <i
                                className="ri-drag-move-line"
                                style={{ opacity: 0.5, fontSize: "14px" }}
                              ></i>
                              {detail.title || `Detail ${index + 1}`}
                              <span
                                className="badge bg-light text-dark ms-1"
                                style={{ fontSize: "0.7rem" }}
                              >
                                {detail.menus?.length || 0}
                              </span>
                              <i
                                className="ri-close-line"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openConfirmModal({
                                    title: "Delete Section",
                                    message:
                                      "Are you sure you want to delete this detail section? This action cannot be undone.",
                                    onConfirm: () => removeSubDetail(index),
                                  });
                                }}
                                style={{
                                  opacity: 0.6,
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  transition: "opacity 0.2s",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.opacity = 1)
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.opacity = 0.6)
                                }
                              />
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                    </div>

                    <TabContent activeTab={activeSubTab}>
                      {formik.values.subDetails.map((detail, dIndex) => (
                        <TabPane tabId={dIndex} key={dIndex}>
                          <div className="p-4">
                            <Card
                              className="mb-4 border-0"
                              style={{ backgroundColor: "#f8f9fa" }}
                            >
                              <CardBody>
                                <Row className="g-3">
                                  <Col md={9}>
                                    <Label className="small text-muted mb-1">
                                      Section Title
                                    </Label>
                                    <Input
                                      value={detail.title}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          `subDetails[${dIndex}].title`,
                                          e.target.value
                                        )
                                      }
                                      placeholder="Enter section title..."
                                      style={{
                                        border: "1px solid #dee2e6",
                                        fontSize: "0.95rem",
                                      }}
                                    />
                                  </Col>
                                  <Col md={3}>
                                    <Label className="small text-muted mb-1">
                                      Display Order
                                    </Label>
                                    <Input
                                      type="number"
                                      value={detail.orderIndex}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          `subDetails[${dIndex}].orderIndex`,
                                          Number(e.target.value)
                                        )
                                      }
                                      style={{ fontSize: "0.95rem" }}
                                    />
                                  </Col>
                                  <Col md={12}>
                                    <FormGroup>
                                      <Label className="small text-muted mb-1">
                                        Description
                                      </Label>
                                      <CKEditor
                                        editor={ClassicEditor}
                                        data={detail?.description}
                                        onChange={(event, editor) =>
                                          formik.setFieldValue(
                                            `subDetails[${dIndex}].description`,
                                            editor.getData()
                                          )
                                        }
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                            {/* Menus Section */}
                            {/* <div className="mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5
                                  className="mb-0"
                                  style={{ fontWeight: 600, color: "#495057" }}
                                >
                                  Menus ({detail.menus?.length || 0})
                                </h5>
                                <Button
                                  size="sm"
                                  color="success"
                                  onClick={() => {
                                    const menus = detail.menus || [];
                                    formik.setFieldValue(
                                      `subDetails[${dIndex}].menus`,
                                      [
                                        ...menus,
                                        {
                                          title: "",
                                          orderIndex: menus.length,
                                          description: "",
                                          contents: [],
                                        },
                                      ]
                                    );
                                    // Auto-switch to the new menu tab
                                    setActiveMenuTab(dIndex, menus.length);
                                  }}
                                  className="d-flex align-items-center gap-1"
                                >
                                  <i
                                    className="ri-add-line"
                                    style={{ fontSize: "14px" }}
                                  ></i>
                                  Add Menu
                                </Button>
                              </div>

                              {detail.menus && detail.menus.length > 0 ? (
                                <Card className="border shadow-sm">
                                  <div
                                    style={{
                                      borderBottom: "2px solid #e9ecef",
                                      backgroundColor: "#f8f9fa",
                                      padding: "0.5rem 1rem",
                                    }}
                                  >
                                    <Nav
                                      className="nav-tabs border-0"
                                      style={{ marginBottom: "-2px" }}
                                    >
                                      {detail.menus.map((menu, mIndex) => (
                                        <NavItem key={mIndex}>
                                          <NavLink
                                            active={
                                              getActiveMenuTab(dIndex) ===
                                              mIndex
                                            }
                                            onClick={() =>
                                              setActiveMenuTab(dIndex, mIndex)
                                            }
                                            className="d-flex align-items-center gap-2 position-relative"
                                            style={{
                                              cursor: "pointer",
                                              border: "none",
                                              borderBottom:
                                                getActiveMenuTab(dIndex) ===
                                                mIndex
                                                  ? "3px solid #0d6efd"
                                                  : "3px solid transparent",
                                              color:
                                                getActiveMenuTab(dIndex) ===
                                                mIndex
                                                  ? "#0d6efd"
                                                  : "#6c757d",
                                              fontWeight:
                                                getActiveMenuTab(dIndex) ===
                                                mIndex
                                                  ? 600
                                                  : 400,
                                              padding: "0.6rem 1rem",
                                              backgroundColor: "transparent",
                                              transition: "all 0.2s",
                                              fontSize: "0.9rem",
                                            }}
                                          >
                                            <i
                                              className="ri-menu-2-line"
                                              style={{ fontSize: "14px" }}
                                            />

                                            {menu.title || `Menu ${mIndex + 1}`}

                                            <span
                                              className="badge bg-light text-dark ms-1"
                                              style={{ fontSize: "0.65rem" }}
                                            >
                                              {menu.contents?.length || 0}
                                            </span>

                                            <i
                                              className="ri-close-line ms-2"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                openConfirmModal({
                                                  title: "Delete Menu",
                                                  message:
                                                    "Are you sure you want to delete this menu? All its contents will be removed.",
                                                  onConfirm: () =>
                                                    removeMenu(dIndex, mIndex),
                                                });
                                              }}
                                              style={{
                                                fontSize: "14px",
                                                opacity: 0.6,
                                                cursor: "pointer",
                                                transition: "opacity 0.2s",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.target.style.opacity = 1)
                                              }
                                              onMouseLeave={(e) =>
                                                (e.target.style.opacity = 0.6)
                                              }
                                            />
                                          </NavLink>
                                        </NavItem>
                                      ))}
                                    </Nav>
                                  </div>

                                  <TabContent
                                    activeTab={getActiveMenuTab(dIndex)}
                                  >
                                    {detail?.menus?.map((menu, mIndex) => (
                                      <TabPane tabId={mIndex} key={mIndex}>
                                        <CardBody
                                          style={{ backgroundColor: "#fafbfc" }}
                                        >
                                          <Row className="g-3 mb-4">
                                            <Col md={8}>
                                              <Label className="small text-muted mb-1">
                                                Menu Title
                                              </Label>
                                              <Input
                                                value={menu.title}
                                                onChange={(e) =>
                                                  formik.setFieldValue(
                                                    `subDetails[${dIndex}].menus[${mIndex}].title`,
                                                    e.target.value
                                                  )
                                                }
                                                placeholder="Enter menu title..."
                                              />
                                            </Col>
                                            <Col md={4}>
                                              <Label className="small text-muted mb-1">
                                                Display Order
                                              </Label>
                                              <Input
                                                type="number"
                                                value={menu.orderIndex}
                                                onChange={(e) =>
                                                  formik.setFieldValue(
                                                    `subDetails[${dIndex}].menus[${mIndex}].orderIndex`,
                                                    Number(e.target.value)
                                                  )
                                                }
                                              />
                                            </Col>
                                            <Col md={12}>
                                              <Label className="small text-muted mb-1">
                                                Description
                                              </Label>
                                              <CKEditor
                                                editor={ClassicEditor}
                                                data={menu.description}
                                                onChange={(event, editor) =>
                                                  formik.setFieldValue(
                                                    `subDetails[${dIndex}].menus[${mIndex}].description`,
                                                    editor.getData()
                                                  )
                                                }
                                              />
                                            </Col>
                                            <Col md={6}>
                                              <Label className="small text-muted mb-1">
                                                PDF Attachment
                                              </Label>

                                              <div className="p-3 border rounded bg-light text-center">
                                                <Button
                                                  size="sm"
                                                  outline
                                                  color="secondary"
                                                  onClick={() =>
                                                    openMediaModal({
                                                      type: "pdf",
                                                      dIndex,
                                                      mIndex,
                                                    })
                                                  }
                                                  className="mb-2"
                                                >
                                                  <i className="ri-file-pdf-line me-1" />
                                                  Upload PDF
                                                </Button>

                                                {menu.pdfId ? (
                                                  <div className="mt-2 text-start small">
                                                    <div className="d-flex align-items-center justify-content-between border rounded px-2 py-1 bg-white">
                                                      <a
                                                        href={`${imageBaseApi}${menu?.pdf?.url}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        download={
                                                          menu?.pdf?.fileName
                                                        }
                                                        className="text-truncate d-flex align-items-center"
                                                        style={{
                                                          maxWidth: "65%",
                                                          textDecoration:
                                                            "none",
                                                          color: "inherit",
                                                        }}
                                                      >
                                                        <i className="ri-file-pdf-line text-danger me-1"></i>
                                                        {menu?.pdf?.fileName}
                                                      </a>

                                                     
                                                      <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() =>
                                                          handleRemovePdf(
                                                            dIndex,
                                                            mIndex
                                                          )
                                                        }
                                                      >
                                                        Remove
                                                      </button>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div className="mt-2 text-muted small">
                                                    No PDF attached
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>

                                          <div className="border-top pt-3 mt-2">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                              <h6
                                                className="mb-0"
                                                style={{
                                                  fontSize: "0.95rem",
                                                  color: "#495057",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                Content Items (
                                                {menu.contents?.length || 0})
                                              </h6>
                                              <Button
                                                size="sm"
                                                color="primary"
                                                onClick={() => {
                                                  const contents =
                                                    menu.contents || [];
                                                  formik.setFieldValue(
                                                    `subDetails[${dIndex}].menus[${mIndex}].contents`,
                                                    [
                                                      ...contents,
                                                      {
                                                        heading: "",
                                                        subHeading: "",
                                                        description: "",
                                                        mediaId: null,
                                                        pdfId: null,
                                                        orderIndex:
                                                          contents.length,
                                                      },
                                                    ]
                                                  );
                                                }}
                                                className="d-flex align-items-center gap-1"
                                              >
                                                <i
                                                  className="ri-add-line"
                                                  style={{ fontSize: "14px" }}
                                                ></i>
                                                Add Content
                                              </Button>
                                            </div>

                                            {menu.contents &&
                                            menu.contents.length > 0 ? (
                                              <div className="d-flex flex-column gap-2">
                                                {menu.contents.map(
                                                  (content, cIndex) => {
                                                    const contentKey = `${dIndex}-${mIndex}-${cIndex}`;
                                                    const isContentExpanded =
                                                      expandedContents[
                                                        contentKey
                                                      ];

                                                    return (
                                                      <Card
                                                        key={cIndex}
                                                        className="border-0 shadow-sm"
                                                        style={{
                                                          backgroundColor:
                                                            "#fff",
                                                        }}
                                                      >
                                                        <div
                                                          onClick={() =>
                                                            toggleContentExpand(
                                                              dIndex,
                                                              mIndex,
                                                              cIndex
                                                            )
                                                          }
                                                          style={{
                                                            padding:
                                                              "0.75rem 1rem",
                                                            cursor: "pointer",
                                                            backgroundColor:
                                                              isContentExpanded
                                                                ? "#e9ecef"
                                                                : "#fff",
                                                            borderBottom:
                                                              isContentExpanded
                                                                ? "1px solid #dee2e6"
                                                                : "none",
                                                          }}
                                                          className="d-flex justify-content-between align-items-center"
                                                        >
                                                          <div className="d-flex align-items-center gap-2">
                                                            <i
                                                              className={
                                                                isContentExpanded
                                                                  ? "ri-arrow-down-s-line"
                                                                  : "ri-arrow-right-s-line"
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            ></i>
                                                            <strong
                                                              style={{
                                                                fontSize:
                                                                  "0.9rem",
                                                              }}
                                                            >
                                                              {content.heading ||
                                                                `Content ${
                                                                  cIndex + 1
                                                                }`}
                                                            </strong>
                                                            <span
                                                              className="badge bg-secondary"
                                                              style={{
                                                                fontSize:
                                                                  "0.65rem",
                                                              }}
                                                            >
                                                              #
                                                              {
                                                                content.orderIndex
                                                              }
                                                            </span>
                                                            {content.mediaId && (
                                                              <i
                                                                className="ri-image-line text-primary"
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                              ></i>
                                                            )}
                                                            {content.pdfId && (
                                                              <i
                                                                className="ri-file-pdf-line text-danger"
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                              ></i>
                                                            )}
                                                          </div>
                                                          <Button
                                                            size="sm"
                                                            color="danger"
                                                            outline
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              openConfirmModal({
                                                                title:
                                                                  "Delete Content",
                                                                message:
                                                                  "Are you sure you want to delete this content item?",
                                                                onConfirm:
                                                                  () => {
                                                                    const updated =
                                                                      [
                                                                        ...menu.contents,
                                                                      ];
                                                                    updated.splice(
                                                                      cIndex,
                                                                      1
                                                                    );
                                                                    formik.setFieldValue(
                                                                      `subDetails[${dIndex}].menus[${mIndex}].contents`,
                                                                      updated
                                                                    );
                                                                  },
                                                              });
                                                            }}
                                                          >
                                                            <i
                                                              className="ri-delete-bin-line"
                                                              style={{
                                                                fontSize:
                                                                  "14px",
                                                              }}
                                                            ></i>
                                                          </Button>
                                                        </div>

                                                        {isContentExpanded && (
                                                          <CardBody>
                                                            <Row className="g-3">
                                                              <Col md={8}>
                                                                <Label className="small text-muted mb-1">
                                                                  Heading
                                                                </Label>
                                                                <Input
                                                                  value={
                                                                    content.heading
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    formik.setFieldValue(
                                                                      `subDetails[${dIndex}].menus[${mIndex}].contents[${cIndex}].heading`,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                  placeholder="Enter content heading..."
                                                                />
                                                              </Col>
                                                              <Col md={4}>
                                                                <Label className="small text-muted mb-1">
                                                                  Order
                                                                </Label>
                                                                <Input
                                                                  type="number"
                                                                  value={
                                                                    content.orderIndex
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    formik.setFieldValue(
                                                                      `subDetails[${dIndex}].menus[${mIndex}].contents[${cIndex}].orderIndex`,
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      )
                                                                    )
                                                                  }
                                                                />
                                                              </Col>
                                                              <Col md={12}>
                                                                <Label className="small text-muted mb-1">
                                                                  Description
                                                                </Label>
                                                                <CKEditor
                                                                  editor={
                                                                    ClassicEditor
                                                                  }
                                                                  data={
                                                                    content.description
                                                                  }
                                                                  onChange={(
                                                                    event,
                                                                    editor
                                                                  ) =>
                                                                    formik.setFieldValue(
                                                                      `subDetails[${dIndex}].menus[${mIndex}].contents[${cIndex}].description`,
                                                                      editor.getData()
                                                                    )
                                                                  }
                                                                />
                                                              </Col>
                                                              <Col md={6}>
                                                                <Label className="small text-muted mb-1">
                                                                  Media
                                                                </Label>
                                                                {content.mediaId ? (
                                                                  <div className="d-flex align-items-center gap-3 p-3 border rounded shadow-sm bg-light">
                                                                    <div
                                                                      style={{
                                                                        width:
                                                                          "80px",
                                                                        height:
                                                                          "80px",
                                                                        borderRadius:
                                                                          "10px",
                                                                        overflow:
                                                                          "hidden",
                                                                        border:
                                                                          "1px solid #ddd",
                                                                        flexShrink: 0,
                                                                      }}
                                                                    >
                                                                      <img
                                                                        src={`${imageBaseApi}${content.media?.url}`}
                                                                        alt="media"
                                                                        style={{
                                                                          width:
                                                                            "100%",
                                                                          height:
                                                                            "100%",
                                                                          objectFit:
                                                                            "cover",
                                                                        }}
                                                                        className="hover-zoom"
                                                                      />
                                                                    </div>

                                                                    <div className="d-flex flex-column justify-content-between flex-grow-1">
                                                                      <div>
                                                                        <div className="fw-semibold">
                                                                          {content
                                                                            .media
                                                                            ?.name ||
                                                                            "Media File"}
                                                                        </div>
                                                                        {content
                                                                          .media
                                                                          ?.size && (
                                                                          <small className="text-muted">
                                                                            Size:{" "}
                                                                            {(
                                                                              content
                                                                                .media
                                                                                .size /
                                                                              1024
                                                                            ).toFixed(
                                                                              1
                                                                            )}{" "}
                                                                            KB
                                                                          </small>
                                                                        )}
                                                                      </div>

                                                                      <div className="d-flex gap-2 mt-2">
                                                                        <Button
                                                                          size="sm"
                                                                          color="primary"
                                                                          outline
                                                                          className="rounded-pill px-3"
                                                                          onClick={() =>
                                                                            openMediaModal(
                                                                              {
                                                                                type: "content",
                                                                                dIndex,
                                                                                mIndex,
                                                                                cIndex,
                                                                              }
                                                                            )
                                                                          }
                                                                        >
                                                                          Change
                                                                        </Button>
                                                                        <Button
                                                                          size="sm"
                                                                          color="danger"
                                                                          outline
                                                                          className="rounded-pill px-3"
                                                                          onClick={() => {
                                                                            formik.setFieldValue(
                                                                              `subDetails[${dIndex}].menus[${mIndex}].contents[${cIndex}].mediaId`,
                                                                              null
                                                                            );
                                                                            formik.setFieldValue(
                                                                              `subDetails[${dIndex}].menus[${mIndex}].contents[${cIndex}].media`,
                                                                              null
                                                                            );
                                                                          }}
                                                                        >
                                                                          <i className="ri-delete-bin-5-line me-1"></i>
                                                                          Remove
                                                                        </Button>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                ) : (
                                                                  <div className="text-center p-4 border rounded bg-light">
                                                                    <i className="ri-image-add-line fs-1 text-secondary"></i>
                                                                    <h6 className="mt-2 mb-2 text-muted">
                                                                      No media
                                                                      added
                                                                    </h6>
                                                                    <h6 className="mb-3 text-muted">
                                                                      Recommended:
                                                                      800 x 800
                                                                    </h6>
                                                                    <Button
                                                                      outline
                                                                      size="sm"
                                                                      color="primary"
                                                                      onClick={() =>
                                                                        openMediaModal(
                                                                          {
                                                                            type: "content",
                                                                            dIndex,
                                                                            mIndex,
                                                                            cIndex,
                                                                          }
                                                                        )
                                                                      }
                                                                    >
                                                                      <i className="ri-image-add-line me-1"></i>{" "}
                                                                      Add Media
                                                                    </Button>
                                                                  </div>
                                                                )}
                                                              </Col>
                                                            </Row>
                                                          </CardBody>
                                                        )}
                                                      </Card>
                                                    );
                                                  }
                                                )}
                                              </div>
                                            ) : (
                                              <Card
                                                className="border-0 text-center py-4"
                                                style={{
                                                  backgroundColor: "#f8f9fa",
                                                }}
                                              >
                                                <CardBody>
                                                  <i
                                                    className="ri-file-list-line text-muted mb-2"
                                                    style={{
                                                      fontSize: "2rem",
                                                      opacity: 0.5,
                                                    }}
                                                  ></i>
                                                  <p className="text-muted small mb-0">
                                                    No content items yet. Click
                                                    "Add Content" to get
                                                    started.
                                                  </p>
                                                </CardBody>
                                              </Card>
                                            )}
                                          </div>
                                        </CardBody>
                                      </TabPane>
                                    ))}
                                  </TabContent>
                                </Card>
                              ) : (
                                <Card
                                  className="border-0 text-center py-5"
                                  style={{ backgroundColor: "#f8f9fa" }}
                                >
                                  <CardBody>
                                    <i
                                      className="ri-menu-line text-muted mb-3"
                                      style={{ fontSize: "3rem", opacity: 0.5 }}
                                    ></i>
                                    <p className="text-muted mb-3">
                                      No menus added yet
                                    </p>
                                    <Button
                                      color="primary"
                                      outline
                                      onClick={() => {
                                        const menus = detail.menus || [];
                                        formik.setFieldValue(
                                          `subDetails[${dIndex}].menus`,
                                          [
                                            ...menus,
                                            {
                                              title: "",
                                              orderIndex: menus.length,
                                              description: "",
                                              contents: [],
                                            },
                                          ]
                                        );
                                        setActiveMenuTab(dIndex, 0);
                                      }}
                                    >
                                      <i className="ri-add-line me-2"></i>
                                      Add Your First Menu
                                    </Button>
                                  </CardBody>
                                </Card>
                              )}
                            </div> */}
                          </div>
                        </TabPane>
                      ))}
                    </TabContent>
                  </CardBody>
                </Card>
              </TabPane>
            </TabContent>
          </form>
        </div>

        {/* Media Modal */}
        <MediaModal
          isOpen={isMediaOpen}
          toggle={() => {
            setIsMediaOpen(false);
            setMediaTarget(null);
          }}
          mediaData={mediaData}
          selectedMedia={
            mediaTarget === "banner"
              ? bannerMedia
              : mediaTarget === "thumbail"
              ? thumbailMedia
              : mediaTarget?.type === "content"
              ? formik.values.subDetails[mediaTarget.dIndex]?.menus[
                  mediaTarget.mIndex
                ]?.contents[mediaTarget.cIndex]?.media || null
              : mediaTarget?.type === "pdf"
              ? formik.values.subDetails[mediaTarget.dIndex]?.menus[
                  mediaTarget.mIndex
                ]?.pdf
              : null
          }
          setSelectedMedia={handleMediaSelect}
        />
      </Container>

      <Modal isOpen={confirmModal.open} toggle={closeConfirmModal} centered>
        <ModalHeader toggle={closeConfirmModal}>
          {confirmModal.title || "Confirm Action"}
        </ModalHeader>

        <ModalBody>
          <p className="mb-0">{confirmModal.message}</p>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" outline onClick={closeConfirmModal}>
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={() => {
              confirmModal.onConfirm?.();
              closeConfirmModal();
            }}
          >
            Yes, Delete
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ServiceForm;
